import { UserRole } from "./user-role.model";

export class User {
    /** Unique internal identity of the user. */
    public id: number = 0;

    /** Unique internal identity of the contact associated with the user. */
    public contactId: number = 0;

    /** A list of role names associated with the user. */
    public roles: string[];

    /** A list of lot relationships (roles) associated with the user. */
    public relationship: UserRole[];

    /** First name of the user. */
    public firstName: string = '';
    
    /** Last name of the user. */
    public lastName: string = '';

    /** Full name of the user. */
    public name: string = '';

    /** Job position of the user. */
    public position: string = '';

    /** Primary email address of the user. */
    public email: string = '';

    /** Preferred language of the user. */
    public languagePreference: string = 'EN';

    /** Current status of the user (pending, active, inactive). */
    public status: string;

    /** Indicates whether or not the current user is considered active. */
    public active: boolean;

    /** Indicates whether or not the user is a bililng admin. */
    public isBillingAdmin: boolean;

    /** Date and time the user was validated (accepted the invite from email). */
    public validated: Date;

    /** Date and time the user last accessed the system. */
    public accessed: Date;

    /** Indicates whether or not the user is currently selected in the UI. */
    public currentUser: boolean;
}